import { createContext, useCallback, useContext, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { selectIsSubscriptionActive } from "../../Redux/subscriptionSlice";

const CheckoutContext = createContext(null);

/** Subscription activation status after Razorpay success (webhook-only activation). */
export const SUBSCRIPTION_STATUS = {
  IDLE: "idle",
  PROCESSING: "processing",
  TIMEOUT: "timeout",
};

export const CheckoutProvider = ({ children }) => {
  const isSubscriptionActive = useSelector(selectIsSubscriptionActive);
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState(null);
  const [cycle, setCycle] = useState("monthly");
  const [subscriptionStatus, setSubscriptionStatus] = useState(SUBSCRIPTION_STATUS.IDLE);

  const openCheckout = useCallback(
    (plan, cycle) => {
      if (isSubscriptionActive) {
        toast.info("You already have an active subscription.");
        return;
      }
      setPlan(plan);
      setCycle(cycle);
      setOpen(true);
      setSubscriptionStatus(SUBSCRIPTION_STATUS.IDLE);
    },
    [isSubscriptionActive]
  );

  const closeCheckout = useCallback(() => {
    setOpen(false);
    setSubscriptionStatus(SUBSCRIPTION_STATUS.IDLE);
  }, []);

  return (
    <CheckoutContext.Provider
      value={{
        open,
        plan,
        cycle,
        openCheckout,
        closeCheckout,
        subscriptionStatus,
        setSubscriptionStatus,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => useContext(CheckoutContext);
